namespace RioERP.Masters {
    export interface WhatsAppMessagesForm {
        Wid: Serenity.IntegerEditor;
        CustomerId: Serenity.IntegerEditor;
        Type: Serenity.EnumEditor;
        Status: Serenity.StringEditor;
        SentDate: Serenity.DateEditor;
        InsertDate: Serenity.DateEditor;
        InsertUserId: Serenity.IntegerEditor;
        IsActive: Serenity.IntegerEditor;
        ErrorMessage: Serenity.StringEditor;
    }

    export class WhatsAppMessagesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.WhatsAppMessages';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WhatsAppMessagesForm.init)  {
                WhatsAppMessagesForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.EnumEditor;
                var w2 = s.StringEditor;
                var w3 = s.DateEditor;

                Q.initFormType(WhatsAppMessagesForm, [
                    'Wid', w0,
                    'CustomerId', w0,
                    'Type', w1,
                    'Status', w2,
                    'SentDate', w3,
                    'InsertDate', w3,
                    'InsertUserId', w0,
                    'IsActive', w0,
                    'ErrorMessage', w2
                ]);
            }
        }
    }
}
